export enum EventStatuses {
  Upcoming = 1,
  Active = 2,
  Live = 3,
  Complete = 4,
}
